import { createSlice } from "@reduxjs/toolkit";
import { revertAll } from "../revertAll/RevertStateReducer";

const initialState = {
  updateProfileLoading: false,
  updateProfileError: null,

  uploadImageLoading: false,
  uploadImageError: null,

  removeImageLoading: false,
  removeImageError: null,

  confirmPasswordLoading: false,
  confirmPasswordError: null,
  passwordConfirmed: false,

  changePasswordLoading: false,
  changePasswordError: null,
  changePasswordSuccess: false,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  extraReducers: (builder) => builder.addCase(revertAll, () => initialState),
  reducers: {
    updateProfileStart(state) {
      state.updateProfileLoading = true;
      state.updateProfileError = null;
    },
    updateProfileSuccess(state) {
      state.updateProfileLoading = false;
    },
    updateProfileFailure(state, action) {
      state.updateProfileLoading = false;
      state.updateProfileError = action.payload;
    },

    uploadImageStart(state) {
      state.uploadImageLoading = true;
      state.uploadImageError = null;
    },
    uploadImageSuccessAction(state) {
      state.uploadImageLoading = false;
    },
    uploadImageFailure(state, action) {
      state.uploadImageLoading = false;
      state.uploadImageError = action.payload;
    },

    removeImageStart(state) {
      state.removeImageLoading = true;
      state.removeImageError = null;
    },
    removeImageSuccessAction(state) {
      state.removeImageLoading = false;
    },
    removeImageFailure(state, action) {
      state.removeImageLoading = false;
      state.removeImageError = action.payload;
    },

    confirmPasswordStart(state) {
      state.confirmPasswordLoading = true;
      state.confirmPasswordError = null;
    },
    confirmPasswordSuccessAction(state) {
      state.confirmPasswordLoading = false;
      state.passwordConfirmed = true;
      state.confirmPasswordError = null;
    },
    confirmPasswordFailure(state, action) {
      state.confirmPasswordLoading = false;
      state.confirmPasswordError = action.payload;
    },

    changePasswordStart(state) {
      state.changePasswordLoading = true;
      state.changePasswordError = null;
      state.changePasswordSuccess = false;
    },
    changePasswordSuccessAction(state) {
      state.changePasswordLoading = false;
      state.changePasswordSuccess = true;
    },
    changePasswordFailure(state, action) {
      state.changePasswordLoading = false;
      state.changePasswordError = action.payload;
    },

    resetPasswordFlow(state) {
      state.passwordConfirmed = false;
      state.confirmPasswordError = null;
      state.changePasswordError = null;
      state.changePasswordSuccess = false;
    },
  },
});

export const {
  updateProfileStart,
  updateProfileSuccess,
  updateProfileFailure,
  uploadImageStart,
  uploadImageSuccessAction,
  uploadImageFailure,
  removeImageStart,
  removeImageSuccessAction,
  removeImageFailure,
  confirmPasswordStart,
  confirmPasswordSuccessAction,
  confirmPasswordFailure,
  changePasswordStart,
  changePasswordSuccessAction,
  changePasswordFailure,
  resetPasswordFlow,
} = settingsSlice.actions;

export default settingsSlice.reducer;